import { render, staticRenderFns } from "./ChartLeakSizeDocuments.vue?vue&type=template&id=e6550bfa&scoped=true&"
import script from "./ChartLeakSizeDocuments.vue?vue&type=script&lang=js&"
export * from "./ChartLeakSizeDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ChartLeakSizeDocuments.vue?vue&type=style&index=0&id=e6550bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6550bfa",
  null
  
)

/* custom blocks */
import block0 from "./ChartLeakSizeDocuments.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports